import { combineReducers } from "redux";
import { documentDecisionSummaryReducer, contractGenPermissionsReducer } from "./summary/reducer";
import {
  documentApprovalLevelsReducer,
  documentApprovalsHistoryReducer,
  approvalTypeDecisionReasonsReducer
} from "./approvalLevels/reducers";
import financedChartReducer from "features/offer/edit/decision/financedChart/reducer";
import folderOffersReducer from "./warranties/reducer";

const documentDecisionReducer = combineReducers({
  summary: documentDecisionSummaryReducer,
  approvalLevels: documentApprovalLevelsReducer,
  approvalsHistory: documentApprovalsHistoryReducer,
  contractGenPermissions: contractGenPermissionsReducer,
  folderOffers: folderOffersReducer,
  financedChart: financedChartReducer,
  approvalTypeDecisionReasons: approvalTypeDecisionReasonsReducer
});

export default documentDecisionReducer;
